import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { PartnerForm, Event } from '../../../../interfaces';
import { UserDataApi, LoopBackAuth, PartnerApi, DiscountRequestApi, VolumeDiscountRateApi, VolumeDiscountRateRequestApi } from '../../../../../assets/js/lb-sdk/services';
import { finalize } from 'rxjs/operators';
import { PARTNER_OBJECT_TYPE, MERCHANT_TYPE, PAYMENT_TYPE, USER_ROLES, USER_APPROVAL_STATUS, SAP_MERCHANT_TYPE, SAP_PAYMENT_TYPE } from '../../../../enums'
import { NgForm } from '@angular/forms';
import { HasRolePipe } from '../../../../pipes/has-role.pipe';
import { TermsAndConditionsAcceptComponent } from '../../../administration/terms-and-conditions/terms-and-conditions-accept/terms-and-conditions-accept.component';
import { BsModalService } from 'ngx-bootstrap';
import { LoadingAndErrors } from '../../../../classes';
import { ToastrService } from 'ngx-toastr';
import { MerchantTypePipe } from '../../../../pipes/merchant-type.pipe';
import { PaymentTypePipe } from '../../../../pipes/payment-type.pipe';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.css']
})
export class RegistrationFormComponent extends LoadingAndErrors implements OnInit {
  @Input() partner: PartnerForm;
  @Input() hideTerms: Boolean;
  @Input() general: Boolean;
  @Input() hideSubmitButton: Boolean;
  @Output('submit') acknowledge = new EventEmitter<Event>();
  @ViewChild('reviewForm') public reviewForm: NgForm;
  discount;
  discountRateRequest;
  volumeDiscountRate;
  volumeDiscountRateRequest;


  REGEX = {
    USERNAME: /^[a-zA-Z]+[a-zA-Z0-9_]*$/,
    USERCODE: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&#;:<>,.`~_\-\+\[\]\\\\/\|\{\}\'\"\=\^\(\)])[A-Za-z\d$@$!%*?&#;:<>,.`~_\-\+\[\]\\\\/\|\{\}\'\"\=\^\(\)]{8,}$/
  };
  PARTNER_OBJECT_TYPE: typeof PARTNER_OBJECT_TYPE = PARTNER_OBJECT_TYPE;
  MERCHANT_TYPE: typeof MERCHANT_TYPE = MERCHANT_TYPE;
  PAYMENT_TYPE: typeof PAYMENT_TYPE = PAYMENT_TYPE;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  USER_APPROVAL_STATUS: typeof USER_APPROVAL_STATUS = USER_APPROVAL_STATUS;

  constructor(
    private userDataApi: UserDataApi,
    private hasRolePipe: HasRolePipe,
    private loopBackAuth: LoopBackAuth,
    private modalService: BsModalService,
    private discountRateRequestApi: DiscountRequestApi,
    private volumeDiscountRateApi: VolumeDiscountRateApi,
    private volumeDiscountRateRequestApi: VolumeDiscountRateRequestApi,
    private partnerApi: PartnerApi,
    private toast: ToastrService,
    private merchantTypePipe: MerchantTypePipe,
    private paymentTypePipe: PaymentTypePipe
  ) {
    super();
  }

  ngOnInit() {
    if (!this.general && this.partner.type === PARTNER_OBJECT_TYPE.MERCHANT) {
      this.loading.discount = true;
      this.discount = undefined;
      this.partnerApi
        .getDiscount(this.partner.partnerId, undefined, true)
        .pipe(finalize(() => {
          this.loading.discount = false;
        }))
        .subscribe(discounts => {
          if (discounts && discounts.length) {
            this.discount = discounts[0];
            switch (this.discount.merchantType) {
              case SAP_MERCHANT_TYPE.DISTRIBUTOR:
                this.partner.merchantType = 'DISTRIBUTOR';
                break;
              case SAP_MERCHANT_TYPE.NATIONAL_RETAILER:
                this.partner.merchantType = 'NATIONAL_RETAILER';
                break;
              case SAP_MERCHANT_TYPE.ONLINE_RETAILER:
                this.partner.merchantType = 'ONLINE_RETAILER';
                break;
              case SAP_MERCHANT_TYPE.KEY_ACCOUNT:
              case SAP_MERCHANT_TYPE.GENERAL_MERCHANT:
              default:
                this.partner.merchantType = 'GENERAL_MERCHANT';
                break;
            }
            switch (this.discount.paymentType) {
              case SAP_PAYMENT_TYPE.CREDIT_TERMS:
                this.partner.paymentType = 'CREDIT_TERMS';
                break;
              case SAP_PAYMENT_TYPE.PAYMENT_FIRST:
              default:
                this.partner.paymentType = 'PAYMENT_FIRST';
                break;
            }
          } else {
            this.loadDiscountRateRequest(this.partner.partnerId);
          }
        }, error => {
          this.loadDiscountRateRequest(this.partner.partnerId);
          this.toast.warning('Merchant type and payment type is set to default.', 'Merchant Details');
        });
    }
  }

  loadDiscountRateRequest(partnerId) {
    this.loading.discountRateRequest = true;
    this.discountRateRequest = undefined;
    this.discountRateRequestApi
      .findOne({
        where: { partnerId: partnerId }
      })
      .pipe(finalize(() => {
        this.loading.discountRateRequest = false;
      }))
      .subscribe((discountRateRequest: any) => {
        this.discountRateRequest = discountRateRequest;
        if (discountRateRequest) {
          switch (this.discountRateRequest.merchantType) {
            case SAP_MERCHANT_TYPE.DISTRIBUTOR:
              this.partner.merchantType = 'DISTRIBUTOR';
              break;
            case SAP_MERCHANT_TYPE.NATIONAL_RETAILER:
              this.partner.merchantType = 'NATIONAL_RETAILER';
              break;
            case SAP_MERCHANT_TYPE.ONLINE_RETAILER:
              this.partner.merchantType = 'ONLINE_RETAILER';
              break;
            case SAP_MERCHANT_TYPE.KEY_ACCOUNT:
            case SAP_MERCHANT_TYPE.GENERAL_MERCHANT:
            default:
              this.partner.merchantType = 'GENERAL_MERCHANT';
              break;
          }
          switch (this.discountRateRequest.paymentType) {
            case SAP_PAYMENT_TYPE.CREDIT_TERMS:
              this.partner.paymentType = 'CREDIT_TERMS';
              break;
            case SAP_PAYMENT_TYPE.PAYMENT_FIRST:
            default:
              this.partner.paymentType = 'PAYMENT_FIRST';
              break;
          }
        } else {
          this.loadVolumeDiscountRate(partnerId);
        }
      }, error => {
        this.loadVolumeDiscountRate(partnerId);
      });
  }

  loadVolumeDiscountRateRequest(partnerId) {
    this.loading.volumeDiscountRateRequest = true;
    this.volumeDiscountRateRequest = undefined;
    this.volumeDiscountRateRequestApi
      .findOne({
        where: { partnerId: partnerId }
      })
      .pipe(finalize(() => {
        this.loading.volumeDiscountRateRequest = false;
      }))
      .subscribe((volumeDiscountRateRequest: any) => {
        this.volumeDiscountRateRequest = volumeDiscountRateRequest;
        this.partner.merchantType = this.merchantTypePipe.transform(this.volumeDiscountRateRequest.merchantType).split(' ').join('_') || 'GENERAL_MERCHANT';
        this.partner.paymentType = this.paymentTypePipe.transform(this.volumeDiscountRateRequest.paymentType).split(' ').join('_') || 'PAYMENT_FIRST';
      }, error => {
        this.partner.merchantType = 'GENERAL_MERCHANT';
        this.partner.paymentType = 'PAYMENT_FIRST';
      });
  }

  loadVolumeDiscountRate(partnerId) {
    this.loading.volumeDiscountRate = true;
    this.volumeDiscountRateApi
      .find({
        where: { partnerId: partnerId }
      })
      .pipe(finalize(() => {
        this.loading.volumeDiscountRate = false;
      }))
      .subscribe(response => {
        this.volumeDiscountRate = response && response[0];
        if (this.volumeDiscountRate) {
          this.partner.merchantType = this.merchantTypePipe.transform(this.volumeDiscountRate.merchantType).split(' ').join('_') || 'GENERAL_MERCHANT';
          this.partner.paymentType = this.paymentTypePipe.transform(this.volumeDiscountRate.paymentType).split(' ').join('_') || 'PAYMENT_FIRST';
        } else {
          this.loadVolumeDiscountRateRequest(partnerId);
        }
      },
      error => {
        this.loadVolumeDiscountRateRequest(partnerId);
      });
  }

  submit(form) {
    if (form.valid) {
      this.acknowledge.emit({ event: 'started' });
      this.userDataApi
        .create({
          partnerId: this.partner.partnerId,
          username: this.partner.username,
          password: this.partner.usercode,
          termsAccepted: this.partner.terms,
          merchantType: this.partner.merchantType ? MERCHANT_TYPE[this.partner.merchantType] : undefined,
          paymentType: this.partner.paymentType ? PAYMENT_TYPE[this.partner.paymentType] : undefined,
          approvalStatus: !this.getUser() ? undefined : (
            this.hasRolePipe.transform(this.getUser().roles, this.USER_ROLES.ALTERNATIVE_CHANNEL) ?
              this.USER_APPROVAL_STATUS.PENDING :
              undefined
          )
        })
        .pipe(finalize(() => {
          this.acknowledge.emit({ event: 'ended' });
        }))
        .subscribe(
          data => {
            this.acknowledge.emit({ event: 'success', data: data });
          },
          error => {
            this.acknowledge.emit({
              event: 'failed',
              data: error.statusCode === 422 &&
                error.message.indexOf('Email already exist') >= 0 ?
                'The email associated with the partner id is found to have an existing record in the system' : (
                  error.message.indexOf('User already exists') >= 0 ?
                  'Username already exists' :
                  (error.message || 'An error occured while processing the request. Please try again.')
                )
            });
          }
        );
    }
  }

  onUsernameChange() {
    this.partner.validCredentials = false;
    this.partner.usernameUsed = false;
  }

  termsAndConditions(data): void {
    const createModal = this.modalService
      .show(TermsAndConditionsAcceptComponent, {
        initialState: { data }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (createModal.content) {
          if (createModal.content.result) {
            this.partner.terms = true;
          } else {
            this.partner.terms = false;
          }
        }
        subscription.unsubscribe();
      });
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
